import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import React from 'react';
import appstyles from '../styles/App.module.scss';

interface IListComponentProps
{
    title: string;
    commands: ICommandBarItemProps[];
    farItems: ICommandBarItemProps[];
}

export const ListComponent: React.FunctionComponent<IListComponentProps> = (props: React.PropsWithChildren<IListComponentProps>) => {
    return <div style={{height:"100%", display:"flex", flexDirection:"column"}}>
            <div className={appstyles.heading}><h3>{props.title}</h3></div>
            <CommandBar className={appstyles.commandBar} items={props.commands} styles={{root: {paddingLeft:"0px"}}} farItems={props.farItems} />
            <div style={{flex:1, minHeight:0}}>
                {props.children}
            </div>     
            </div>
}

export default ListComponent;